// VIEWS
export const UPLOAD_ART_VIEW = 'design';
export const CUSTOMIZE_VIEW = 'customize';
export const WHITE_INK_OPTIONS_VIEW = 'white-options';
export const ERROR_MODE_VIEW = 'error';
export const APPLY_CODES_VIEW = 'apply-codes';
export const LOGIN_SIGNUP_VIEW = 'login-signup';

// PRODUCT PROFILES
export const ROLL_LABEL = 'ROLL_LABEL';
export const DESIGN_IN_LABEL = 'DESIGN_IN_LABEL';
export const CUSTOM_SIZE_STICKER = 'CUSTOM_SIZE_STICKER';
export const CUSTOM_SHAPE_STICKER = 'CUSTOM_SHAPE_STICKER';

// HELP DIALOG
export const HELP_SECTION_PRODUCT_TYPE = 'HELP_SECTION_PRODUCT_TYPE';
export const HELP_SECTION_UPLOAD_ART = 'HELP_SECTION_UPLOAD_ART';
export const HELP_SECTION_ART_SIZE_POSITION = 'HELP_SECTION_ART_SIZE_POSITION';
export const HELP_SECTION_SAFETY_TRIM_AND_BLEED = 'HELP_SECTION_SAFETY_TRIM_AND_BLEED';
export const HELP_SECTION_APPLY_CODES = 'HELP_SECTION_APPLY_CODES';
export const HELP_SECTION_REQUEST_CODES = 'HELP_SECTION_REQUEST_CODES';
export const HELP_SECTION_UPLOAD_CODES = 'HELP_SECTION_UPLOAD_CODES';
export const HELP_SECTION_WHITE_INK = 'HELP_SECTION_WHITE_INK';

export const HELP_TOPIC_UPLOAD_ART = 'help-topic-upload-art';
export const HELP_TOPIC_UPLOAD_ART_DESIGN_IN = 'help-topic-design-in-upload-art';
export const HELP_TOPIC_UPLOAD_ART_LABEL_SHAPE_YOUR_UPLOAD = 'help-topic-upload-label-shape';
export const HELP_TOPIC_UPLOAD_ART_PREPARE_FILES = 'help-topic-upload-art-prepare-files';

export const HELP_TOPIC_ART_SIZE_POSITION = 'help-topic-art-position';
export const HELP_TOPIC_SHAPE_AND_SIZE = 'help-topic-shape-and-size';
export const HELP_TOPIC_POSITION_AND_ROTATION = 'help-topic-position-and-rotation';
export const HELP_TOPIC_CONTOUR_AND_BACKGROUND = 'help-topic-contour-and-background';
export const HELP_TOPIC_ART_SIZE_POSITION_STB_LINES = 'help-topic-STB-lines';
export const HELP_TOPIC_SHAPE_CORNERS_SIZE = 'help-topic-shape-corners-size-sheet';
export const HELP_TOPIC_ART_SIZE_POSITION_STRETCHED = 'help-topic-art-position-art-stretched';
export const HELP_TOPIC_ART_SIZE_POSITION_OPTIMIZED = 'help-topic-art-position-art-optimized';
export const HELP_TOPIC_ART_SIZE_POSITION_FLATTENED = 'help-topic-art-position-art-flattened';
export const HELP_TOPIC_ART_SIZE_POSITION_ADJUSTED = 'help-topic-art-position-art-adjusted';
export const HELP_TOPIC_WHITE_INK = 'help-topic-white-ink';
export const HELP_TOPIC_WHITE_INK_OPTIONS = 'help-topic-white-ink-options';
export const HELP_TOPIC_WHITE_INK_IN_YOUR_UPLOAD = 'help-topic-white-ink-in-your-upload';

export const HELP_TOPIC_PRODUCT_TYPE = 'help-topic-product-type';
export const HELP_TOPIC_TRANSPARENCY_CODES = 'help-topic-product-type-design-in';
export const HELP_TOPIC_ROLL_LABELS = 'help-topic-product-type-roll';
export const HELP_TOPIC_DIE_CUT_STICKERS = 'help-topic-product-type-sticker';
export const HELP_TOPIC_SHEET_LABELS = 'help-topic-product-type-sheet';

export const HELP_TOPIC_CONTACT_US = 'help-topic-contact-us';

export const HELP_TOPIC_APPLY_CODES = 'help-topic-apply-codes';
export const HELP_TOPIC_REQUEST_CODES = 'help-topic-request-codes';
export const HELP_TOPIC_UPLOAD_CODES = 'help-topic-upload-codes';
export const HELP_TOPIC_APPLY_CODES_SIGN_IN = 'help-topic-apply-codes-sign-in';
export const HELP_TOPIC_APPLY_CODES_REGISTER = 'help-topic-apply-codes-register';
export const HELP_TOPIC_APPLY_CODES_AUTHORIZE_CODES = 'help-topic-apply-codes-authorize-codes';
export const HELP_TOPIC_APPLY_CODES_REQUEST_CODES = 'help-topic-apply-codes-request-codes';
export const HELP_TOPIC_APPLY_CODES_UPLOAD_CODES = 'help-topic-apply-codes-upload-codes';

export const HELP_TOPIC_STICKER_DESIGN = 'help-topic-sticker-design';
export const HELP_TOPIC_SHEET_SIZE = 'help-topic-sheet';

// WORKING AREA WARNINGS
export const WORKING_AREA_WARNING_OPTIMIZED_CODES = [601, 605];
export const WORKING_AREA_WARNING_STRETCHED_CODE = 609;
export const WORKING_AREA_WARNING_FLATTENED_CODE = 608;
export const WORKING_AREA_WARNING_ADJUSTED_CODE = 607;

export const WORKING_AREA_WARNING_CUSTOM_SHAPE_CODE = 'WORKING_AREA_WARNING_CUSTOM_SHAPE_CODE';
export const WORKING_AREA_WARNING_HPI_WHITE_CODE = 'WORKING_AREA_WARNING_HPI_WHITE_CODE';
export const WORKING_AREA_WARNING_CUSTOM_SHAPE_HPI_WHITE_CODE = 'WORKING_AREA_WARNING_CUSTOM_SHAPE_HPI_WHITE_CODE';

export const WORKING_AREA_WARNING_OPTIMIZED_KEY = 'qau-working-area-error-tip-optimized';
export const WORKING_AREA_WARNING_STRETCHED_KEY = 'qau-working-area-error-tip-stretched';
export const WORKING_AREA_WARNING_FLATTENED_KEY = 'qau-working-area-error-tip-flattened';
export const WORKING_AREA_WARNING_ADJUSTED_KEY = 'qau-working-area-error-tip-adjusted';
export const WORKING_AREA_WARNING_CUSTOM_SHAPE_KEY = 'qau-working-area-error-tip-custom-shape';
export const WORKING_AREA_WARNING_HPI_WHITE_KEY = 'qau-working-area-error-tip-hpi-white';
export const WORKING_AREA_WARNING_CUSTOM_SHAPE_HPI_WHITE_KEY = 'qau-working-area-error-tip-custom-shape-hpi-white';

// APPLY CODES VIEW STEPS
export const UPLOAD_CODES_FLOW = 'UPLOAD_CODES_FLOW';
export const REQUEST_CODES_FLOW = 'REQUEST_CODES_FLOW';
export const APPLY_CODES_FLOW_SELECTION = 'APPLY_CODES_FLOW_SELECTION';
export const AUTHORIZE_CODES_FLOW = 'AUTHORIZE_CODES_FLOW';
export const AUTHORIZATION_SENT = 'AUTHORIZATION_SENT';
export const LOGIN_SIGNUP_FLOW = 'LOGIN_SIGNUP_FLOW';
export const LOGIN_FORM = 'LOGIN_FORM';
export const FORGOT_PASSWORD_FORM = 'FORGOT_PASSWORD_FORM';
export const SIGNUP_FORM = 'SIGNUP_FORM';

export const CORNER_TYPES = {
  ROUNDED_CORNER: 'rounded',
  SQUARED_CORNER: 'squared',
  SCALLOPED_CORNER: 'scalloped_corner',
  SMOOTH_EDGE: 'smooth_edge',
  SCALLOPED_EDGE: 'scalloped_edge',
};

export const HELP_PRODUCT_TYPES_LABELS = ['roll', 'sticker', 'sheet', 'design-in'];
export const HELP_UPLOAD_ART_LABELS = ['roll-', 'sticker-', 'sheet-', 'design-in-'];
export const HELP_ART_SIZE_LABELS = ['sticker-design-custom', 'sticker-design-known', 'sheet', 'design-in', 'art-position'];
export const HELP_WHITE_INK_LABELS = ['sheet-', ''];
